import { Id, toast } from 'react-toastify'

let currentToastId: Id | null = null // 현재 toast ID 저장

export const handleCopy = async (string?: string) => {
  // copy string to clipboard
  try {
    if (currentToastId || !string) return // 기존 toast가 실행 중이면 함수 종료

    await navigator.clipboard.writeText(string)
    // 토스트 메시지 표시
    currentToastId = toast.success('Copied to clipboard', {
      onClose: () => {
        currentToastId = null // 토스트가 닫히면 ID 초기화
      },
    })
  } catch (err) {
    console.error('Failed to copy: ', err)
  }
}

export const updateDecimal = (value: string, setDecimal: (value: string) => void, decimal: number = 8) => {
  const regex = decimal === 0 ? new RegExp(`^\\d*$`) : new RegExp(`^\\d*(\\.\\d{0,${decimal}})?$`)

  if (regex.test(value)) {
    setDecimal(value)
    return true
  } else {
    return false
  }
}

export function debounce<T extends (...args: any[]) => any>(func: T, wait: number) {
  let timeout: NodeJS.Timeout
  return function(this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(this, args), wait)
  }
}

// 로컬스토리지 업데이트
export const setLocalStorage = (key: string, value: any) => {
  try {
    if (typeof Storage !== 'undefined') {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      console.error('Local storage is not supported by this browser.')
    }
  } catch (e) {
    if (e instanceof DOMException && e.code === 22) {
      console.error('Local storage is full.')
    } else {
      console.error('An error occurred while setting local storage:', e)
    }
  }
}

// 로컬스토리지 가져오기
export const getLocalStorage = (key: string) => {
  try {
    if (typeof Storage !== 'undefined') {
      const value = localStorage.getItem(key)
      if (value) {
        try {
          return JSON.parse(value)
        } catch {
          // JSON 파싱 실패 시 원래 문자열 반환
          return value
        }
      }
      return null
    } else {
      console.error('Local storage is not supported by this browser.')
    }
  } catch (e) {
    console.error('An error occurred while getting local storage:', e)
  }
}
